<template>
    <section class="space-y-4">
        <h3 class="text-lg font-semibold">{{ t('reservation.step6.thankYou') }}</h3>
        <p class="text-sm text-gray-700">{{ t('reservation.step6.confirmationMessage') }}</p>
        <div class="rounded-lg border border-primary/30 bg-primary/5 px-4 py-3 text-sm">
            <span class="font-medium text-gray-700">{{ t('reservation.step6.referenceLabel') }}:</span>
            <span class="ml-2 font-semibold text-primary">{{ reservationReference || '-' }}</span>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useTranslations } from '@/composables/useTranslations';

const { t } = useTranslations();

defineProps<{
    reservationReference?: string;
}>();
</script>
